import React from 'react'

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'

import { SharedDatesProvider } from '@contexts/sharedDates'
import { SearchScreen } from '@screens/Main/Search'
import { TaskView } from '@screens/Task/containers'
import { AddAssignmentFormScreen } from '@screens/Task/containers/AssignmentsSection/FormScreen/AddAssignment'
import { EditAssignmentFormScreen } from '@screens/Task/containers/AssignmentsSection/FormScreen'
import { AddBarrierFormScreen } from '@screens/Task/containers/BarriersSection/FormScreen/AddBarrier'
import { EditBarrierFormScreen } from '@screens/Task/containers/BarriersSection/FormScreen/EditBarrier'
import { EditTaskFormScreen } from '@screens/Task/containers/TaskSection/FormScreens/Forms/EditTask'
import { ResetPullAheadFormScreen } from '@screens/Task/containers/TaskSection/FormScreens/Forms/ResetPullAhead'

import { AddTaskRoutes } from './AddTaskRoutes'
import { HomeTabs } from './MainRoutes'

export type MainRoutesParamsList = {
  networkLogger: undefined
  signIn: undefined
  forbidden: undefined
  todo: undefined
  weekView: undefined
  mechanical: undefined
  process: undefined
  profile: undefined
  task: { taskId: number }
  tabs: undefined
  filters: undefined
  search: undefined
}

export type TaskRoutesParamsList = MainRoutesParamsList & {
  editAssignmentFormScreen: {
    assignmentId: number
    taskId: number
    duration: number
  }
  addBarrierFormScreen: { taskId: number }
  editBarrierFormScreen: { taskId: number; barrierId: number }
  editTaskFormScreen: { taskId: number }
  resetPullAheadFormScreen: { taskId: number }
  addTask: undefined
}

export type RoutesParamsList = MainRoutesParamsList & TaskRoutesParamsList

export function AppRoutes() {
  return (
    <BrowserRouter>
      <SharedDatesProvider>
        <Routes>
          <Route path="/*" element={<HomeTabs />} />
          <Route path="/search" element={<SearchScreen />} />
          <Route path="/task/:taskId" element={<TaskView />} />
          <Route
            path="/task/:taskId/add-assignment"
            element={<AddAssignmentFormScreen />}
          />
          <Route
            path="/task/:taskId/edit-assignment/:assignmentId"
            element={<EditAssignmentFormScreen />}
          />
          <Route
            path="/task/:taskId/edit"
            element={<EditTaskFormScreen />}
          />
          <Route path="/task/:taskId/add-task/*" element={<AddTaskRoutes />} />
          <Route
            path="/task/:taskId/reset-pull-ahead"
            element={<ResetPullAheadFormScreen />}
          />
          <Route
            path="/task/:taskId/add-barrier"
            element={<AddBarrierFormScreen />}
          />
          <Route
            path="/task/:taskId/edit-barrier/:barrierId"
            element={<EditBarrierFormScreen />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </SharedDatesProvider>
    </BrowserRouter>
  )
}
